// App.jsx - COMPLETE PRODUCTION-READY CODE
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// =====================================================
// CORE COMPONENT IMPORTS
// =====================================================
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import GlobalEnquiryPopup from "./components/GlobalEnquiryPopup";

// =====================================================
// CORE PAGE IMPORTS
// =====================================================
import Home from "./pages/Home";
import About from "./pages/About";
import OurWork from "./pages/OurWork";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// =====================================================
// EXISTING SERVICES (WORKING)
// =====================================================
import MSMERegistration from "./components/ourservices/MSMERegistration";
import EPFRegistration from "./components/ourservices/EPFRegistration";
import ShopEstablishmentRegistration from "./components/ourservices/ShopEstablishmentRegistration";
import LLPAnnualCompliance from "./components/ourservices/LLPAnnualCompliance";
import AnnualCompliance from "./components/ourservices/AnnualCompliance";
import OutsourceBookkeepingServices from "./components/ourservices/OutsourceBookkeepingServices";
import BookKeepingAccountingServices from "./components/ourservices/BookKeepingAccountingServices";
import NidhiCompanyCompliance from "./components/ourservices/NidhiCompanyCompliance";
import NGOCompliance from "./components/ourservices/NGOCompliance";
import AnnualComplianceForSociety from "./components/ourservices/AnnualComplianceForSociety";
import PartnershipAnnualCompliance from "./components/ourservices/PartnershipAnnualCompliance";
import TrustAnnualCompliance from "./components/ourservices/TrustAnnualCompliance";
import PartnershipFirmTaxReturnFiling from "./components/ourservices/PartnershipFirmTaxReturnFiling";
import AppointmentOfAuditor from "./components/ourservices/AppointmentOfAuditor";
import FormINC20A from "./components/ourservices/FormINC20A";
import ChangeRegisteredOffice from "./components/ourservices/ChangeRegisteredOffice";
import ChangeInObjectClause from "./components/ourservices/ChangeInObjectClause";
import RevivalOfStruckOffCompanies from "./components/ourservices/RevivalOfStruckOffCompanies";
import DirectorPartnerChanges from "./components/ourservices/DirectorPartnerChanges";
import DIR3KYCForDirectors from "./components/ourservices/DIR3KYCForDirectors";
import CompanyWindingUp from "./components/ourservices/CompanyWindingUp";
import IncreaseAuthorizedCapital from "./components/ourservices/IncreaseAuthorizedCapital";
import ConvertPartnershipIntoLLP from "./components/ourservices/ConvertPartnershipIntoLLP";
import TrademarkServices from "./components/ourservices/TrademarkServices";
import IPRegistrationDispute from "./components/ourservices/IPRegistrationDispute";
import IncomeTaxTDSReturnsITRFilings from "./components/ourservices/IncomeTaxTDSReturnsITRFilings";
import GSTServices from "./components/ourservices/GSTServices";
import OnlineCharteredAccountantServices from "./components/ourservices/OnlineCharteredAccountantServices";
import MergersAcquisitions from "./components/ourservices/MergersAcquisitions";
import FinancialConsultancyModeling from "./components/ourservices/FinancialConsultancyModeling";
import PaymentGatewayAggregatorSolutions from "./components/ourservices/PaymentGatewayAggregatorSolutions";
import StartupPlanningCSR from "./components/ourservices/StartupPlanningCSR";
import ConsumerComplaint from "./components/ourservices/ConsumerComplaint";
import ChequeBounceNotice from "./components/ourservices/ChequeBounceNotice";

// =====================================================
// REGISTRATION IMPORTS
// =====================================================
import CompanyRegistration from "./components/CompanyRegistration";
import PvtCompanyRegistration from "./components/PvtCompanyRegistration";
import LlpRegistration from "./components/registration/LlpRegistration";
import PublicLimitedCompanyRegistration from "./components/registration/PublicLimitedCompanyRegistration";
import PartnershipFirmRegistration from "./components/registration/PartnershipFirmRegistration";
import SoleProprietorshipRegistration from "./components/registration/SoleProprietorshipRegistration";
import OPCRegistration from "./components/registration/OPCRegistration";
import StartupRegistration from "./components/registration/StartupRegistration";
import StartupIndiaRegistration from "./components/registration/StartupIndiaRegistration";
import IndianSubsidiaryRegistration from "./components/registration/IndianSubsidiaryRegistration";
import ForeignSubsidiaryRegistration from "./components/registration/ForeignSubsidiaryRegistration";
import ForeignCompanyRegistration from "./components/registration/ForeignCompanyRegistration";
import ProducerCompanyRegistration from "./components/registration/ProducerCompanyRegistration";
import NidhiCompanyRegistration from "./components/registration/NidhiCompanyRegistration";
import MicrofinanceCompanyRegistration from "./components/registration/MicrofinanceCompanyRegistration";
import SSIRegistration from "./components/registration/SSIRegistration";
import VirtualOfficeRegistration from "./components/registration/VirtualOfficeRegistration";
import NGORegistration from "./components/registration/NGORegistration";
import TrustRegistration from "./components/registration/TrustRegistration";
import SocietyRegistration from "./components/registration/SocietyRegistration";
import Section8CompanyRegistration from "./components/registration/Section8CompanyRegistration";
import Section8MicrofinanceRegistration from "./components/registration/Section8MicrofinanceRegistration";
import DarpanRegistration from "./components/registration/DarpanRegistration";
import NGO12A80GRegistration from "./components/registration/NGO12A80GRegistration";
import FCARegistration from "./components/registration/FCARegistration";
import NGOAccountingServices from "./components/registration/NGOAccountingServices";

// =====================================================
// LICENSES & CERTIFICATIONS
// =====================================================
import WordmarkRegistration from "./components/registration/WordmarkRegistration";
import BarcodeRegistration from "./components/registration/BarcodeRegistration";
import DrugLicenseRegistration from "./components/registration/DrugLicenseRegistration";
import LiquorLicenseRegistration from "./components/registration/LiquorLicenseRegistration";
import AYUSHLicenseRegistration from "./components/registration/AYUSHLicenseRegistration";
import FactoryLicenseRegistration from "./components/registration/FactoryLicenseRegistration";
import PetrolPumpLicenseRegistration from "./components/registration/PetrolPumpLicenseRegistration";
import TobaccoLicenseRegistration from "./components/registration/TobaccoLicenseRegistration";
import NetworkLicenseRegistration from "./components/registration/NetworkLicenseRegistration";
import ICEGATERegistration from "./components/registration/ICEGATERegistration";
import ISSNNumberRegistration from "./components/registration/ISSNNumberRegistration";
import ISBNNumberRegistration from "./components/registration/ISBNNumberRegistration";
import ProfessionalTaxRegistration from "./components/registration/ProfessionalTaxRegistration";
import PTECRegistration from "./components/registration/PTECRegistration";
import RCMCRegistration from "./components/registration/RCMCRegistration";
import SPICePlusFormFiling from "./components/registration/SPICePlusFormFiling";

// =====================================================
// ISO CERTIFICATIONS
// =====================================================
import ISOCertification from "./components/registration/ISOCertification";
import ISO9001Certification from "./components/registration/ISO9001Certification";
import ISO14001Certification from "./components/registration/ISO14001Certification";
import ISO22000FSMSCertification from "./components/registration/ISO22000FSMSCertification";
import ISO27001Certification from "./components/registration/ISO27001Certification";
import ISO31000Certification from "./components/registration/ISO31000Certification";
import ISO50001Certification from "./components/registration/ISO50001Certification";
import ISIMarkCertification from "./components/registration/ISIMarkCertification";

// =====================================================
// BIS & OTHER CERTIFICATIONS
// =====================================================
import BISCertification from "./components/registration/BISCertification";
import BISPowerBankCertification from "./components/registration/BISPowerBankCertification";
import BISFMCSCertification from "./components/registration/BISFMCSCertification";
import BISToyCertification from "./components/registration/BISToyCertification";
import SA8000Certification from "./components/registration/SA8000Certification";
import GMPCertification from "./components/registration/GMPCertification";

// =====================================================
// EXPORT & TRADE
// =====================================================
import FIEORegistration from "./components/registration/FIEORegistration";
import DUNSNumberRegistration from "./components/registration/DUNSNumberRegistration";
import GIRegistration from "./components/registration/GIRegistration";

// =====================================================
// FSSAI SERVICES
// =====================================================
import FSSAIRegistration from "./components/registration/FSSAIRegistration";
import FSSAIStateLicense from "./components/registration/FSSAIStateLicense";
import FSSAICentralLicense from "./components/registration/FSSAICentralLicense";
import FSSAIProductApproval from "./components/registration/FSSAIProductApproval";
import FSSAILicenseRenewal from "./components/registration/FSSAILicenseRenewal";
import HalalCertification from "./components/registration/HalalCertification";

// =====================================================
// LOCAL LICENSES
// =====================================================
import TradeLicense from "./components/registration/TradeLicense";
import MSTCLicense from "./components/registration/MSTCLicense";
import GumastaLicense from "./components/registration/GumastaLicense";
import RERARegistration from "./components/registration/RERARegistration";
import NSICRegistration from "./components/registration/NSICRegistration";
import PESOCertificate from "./components/registration/PESOCertificate";
import HallmarkRegistration from "./components/registration/HallmarkRegistration";

// =====================================================
// COMMODITY BOARDS
// =====================================================
import RubberBoardRegistration from "./components/registration/RubberBoardRegistration";
import TeaBoardRegistration from "./components/registration/TeaBoardRegistration";
import InsuranceRepositoryRegistration from "./components/registration/InsuranceRepositoryRegistration";
import SEPCRegistration from "./components/registration/SEPCRegistration";
import GJEPCRegistration from "./components/registration/GJEPCRegistration";
import ISPLicenseRegistration from "./components/registration/ISPLicenseRegistration";
import IJCEPACertificate from "./components/registration/IJCEPACertificate";
import FPOMarkCertification from "./components/registration/FPOMarkCertification";
import SpiceBoardRegistration from "./components/registration/SpiceBoardRegistration";
import BEERegistration from "./components/registration/BEERegistration";

// =====================================================
// GOVERNMENT INITIATIVES
// =====================================================
import MakeInIndiaCertificate from "./components/registration/MakeInIndiaCertificate";
import ZEDCertification from "./components/registration/ZEDCertification";
import NSDCRegistration from "./components/registration/NSDCRegistration";
import NGOProjectReport from "./components/registration/NGOProjectReport";
import CMMICertification from "./components/registration/CMMICertification";

// =====================================================
// EXPORT COUNCILS
// =====================================================
import APEDARegistration from "./components/registration/APEDARegistration";
import TEXPROCILRegistration from "./components/registration/TEXPROCILRegistration";
import CertificateOfGoodStanding from "./components/registration/CertificateOfGoodStanding";
import CECertification from "./components/registration/CECertification";
import RNIRegistration from "./components/registration/RNIRegistration";
import CDSCORegistration from "./components/registration/CDSCORegistration";
import ADCodeRegistration from "./components/registration/ADCodeRegistration";
import GSPRegistration from "./components/registration/GSPRegistration";
import SAFTALicense from "./components/registration/SAFTALicense";
import WPCRegistration from "./components/registration/WPCRegistration";
import AGMARKLicenseRegistration from "./components/registration/AGMARKLicenseRegistration";
import RegistrationLicensing from "./pages/registration/RegistrationLicensing";
import VirtualCFO from "./components/registration/VirtualCFO";

// =====================================================
// INTERNATIONAL REGISTRATIONS
// =====================================================
import CompanyRegistrationDubai from "./components/registration/CompanyRegistrationDubai";
import DubaiFreeZoneRegistration from "./components/registration/DubaiFreeZoneRegistration";
import UKCompanyRegistration from "./components/registration/UKCompanyRegistration";
import CanadaCompanyRegistration from "./components/registration/CanadaCompanyRegistration";
import AustraliaCompanyRegistration from "./components/registration/AustraliaCompanyRegistration";
import USACompanyRegistration from "./components/registration/USACompanyRegistration";
import NewZealandCompanyRegistration from "./components/registration/NewZealandCompanyRegistration";
import HongKongCompanyRegistration from "./components/registration/HongKongCompanyRegistration";
import SingaporeCompanyRegistration from "./components/registration/SingaporeCompanyRegistration";
import MalaysiaCompanyRegistration from "./components/registration/MalaysiaCompanyRegistration";
import ThailandCompanyRegistration from "./components/registration/ThailandCompanyRegistration";
import IndonesiaCompanyRegistration from "./components/registration/IndonesiaCompanyRegistration";
import QatarCompanyRegistration from "./components/registration/QatarCompanyRegistration";
import OmanCompanyRegistration from "./components/registration/OmanCompanyRegistration";
import SaudiArabiaCompanyRegistration from "./components/registration/SaudiArabiaCompanyRegistration";
import FranceCompanyRegistration from "./components/registration/FranceCompanyRegistration";
import GermanyCompanyRegistration from "./components/registration/GermanyCompanyRegistration";
import ItalyCompanyRegistration from "./components/registration/ItalyCompanyRegistration";
import SwedenCompanyRegistration from "./components/registration/SwedenCompanyRegistration";
import IrelandCompanyRegistration from "./components/registration/IrelandCompanyRegistration";
import NetherlandsCompanyRegistration from "./components/registration/NetherlandsCompanyRegistration";
import MauritiusCompanyRegistration from "./components/registration/MauritiusCompanyRegistration";
import BritishVirginIslandsCompanyRegistration from "./components/registration/BritishVirginIslandsCompanyRegistration";

// =====================================================
// ADVISORY SERVICES
// =====================================================
import CooperativeBanking from "./pages/advisory/CooperativeBanking";
import TenderBid from "./pages/advisory/TenderBid";
import WealthManagement from "./pages/advisory/WealthManagement";
import StrategyManagement from "./pages/advisory/StrategyManagement";
import HNIFamilyOffice from "./pages/advisory/HNIFamilyOffice";
import GovernmentInfrastructure from "./pages/advisory/GovernmentInfrastructure";
import G2GTreaties from "./pages/advisory/G2GTreaties";
import PolicyAdvocacy from "./pages/advisory/PolicyAdvocacy";
import PolicyAdvisoryGovernment from "./pages/advisory/PolicyAdvisoryGovernment";

// =====================================================
// MOBILE BOTTOM NAVBAR COMPONENT
// =====================================================
const MobileBottomNavbar = () => {
  const navigate = useNavigate();

  const handleCallClick = () => {
    window.open("tel:+919217468906", "_self");
  };

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-200 z-40 shadow-2xl"
      style={{ maxHeight: "80px" }}
    >
      <div className="flex h-16 px-4 items-center justify-between gap-3">
        <motion.button
          onClick={handleCallClick}
          whileTap={{ scale: 0.92 }}
          whileHover={{ scale: 1.02 }}
          className="flex-1 h-12 bg-transparent border-4 border-black rounded-xl flex items-center justify-center shadow-lg hover:shadow-xl active:shadow-md transition-all duration-200 text-black font-semibold text-sm"
          aria-label="Call Us at +91 9217468906"
        >
          <svg className="w-5 h-5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          Call
        </motion.button>

        <motion.button
          onClick={handleContactClick}
          whileTap={{ scale: 0.92 }}
          whileHover={{ scale: 1.02 }}
          className="flex-1 h-12 bg-transparent border-4 border-black rounded-xl flex items-center justify-center shadow-lg hover:shadow-xl active:shadow-md transition-all duration-200 text-black font-semibold text-sm"
          aria-label="Go to Contact Page"
        >
          <svg className="w-5 h-5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Contact
        </motion.button>
      </div>
    </motion.div>
  );
};

// =====================================================
// WHATSAPP ICON COMPONENT
// =====================================================
const WhatsAppIcon = ({ size = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 256 258" fill="white">
    <defs>
      <linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#1faf38" />
        <stop offset="100%" stopColor="#60d669" />
      </linearGradient>
      <linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#f9f9f9" />
        <stop offset="100%" stopColor="#fff" />
      </linearGradient>
    </defs>
    <path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a122.994 122.994 0 0058.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004" />
    <path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z" />
    <path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561c0 15.67 11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716c-3.186-1.593-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64" />
  </svg>
);

// =====================================================
// MAIN APP COMPONENT
// =====================================================
export default function App() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906";
    const message = "Hello! I'd like to know more about your consultancy services.";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
  };

  return (
    <BrowserRouter>
      <div className="relative pb-20 md:pb-0 min-h-screen">
        <Navbar />
        <GlobalEnquiryPopup />

        <Routes>
          {/* ==================== CORE ROUTES ==================== */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* ==================== OUR SERVICES ROUTES ==================== */}
          <Route path="/msme-registration" element={<MSMERegistration />} />
          <Route path="/epf-registration" element={<EPFRegistration />} />
          <Route path="/shop-establishment-registration" element={<ShopEstablishmentRegistration />} />
          <Route path="/llp-annual-compliance" element={<LLPAnnualCompliance />} />
          <Route path="/private-limited-annual-compliance" element={<AnnualCompliance />} />
          <Route path="/outsource-bookkeeping" element={<OutsourceBookkeepingServices />} />
          <Route path="/bookkeeping-accounting" element={<BookKeepingAccountingServices />} />
          <Route path="/nidhi-company-compliance" element={<NidhiCompanyCompliance />} />
          <Route path="/ngo-compliance" element={<NGOCompliance />} />
          <Route path="/society-annual-compliance" element={<AnnualComplianceForSociety />} />
          <Route path="/partnership-firm-compliance" element={<PartnershipAnnualCompliance />} />
          <Route path="/trust-annual-compliance" element={<TrustAnnualCompliance />} />
          <Route path="/partnership-firm-tax-return" element={<PartnershipFirmTaxReturnFiling />} />
          <Route path="/appointment-of-auditor" element={<AppointmentOfAuditor />} />
          <Route path="/inc-20a-filing" element={<FormINC20A />} />
          <Route path="/change-registered-office" element={<ChangeRegisteredOffice />} />
          <Route path="/change-object-clause" element={<ChangeInObjectClause />} />
          <Route path="/revival-of-company" element={<RevivalOfStruckOffCompanies />} />
          <Route path="/change-director" element={<DirectorPartnerChanges />} />
          <Route path="/dir-3-kyc" element={<DIR3KYCForDirectors />} />
          <Route path="/winding-up-company" element={<CompanyWindingUp />} />
          <Route path="/increase-authorized-capital" element={<IncreaseAuthorizedCapital />} />
          <Route path="/convert-partnership-to-llp" element={<ConvertPartnershipIntoLLP />} />
          <Route path="/trademark-registration" element={<TrademarkServices />} />
          <Route path="/ip-dispute-services" element={<IPRegistrationDispute />} />
          <Route path="/tds-return" element={<IncomeTaxTDSReturnsITRFilings />} />
          <Route path="/gst-registration" element={<GSTServices />} />
          <Route path="/online-ca" element={<OnlineCharteredAccountantServices />} />
          <Route path="/mergers-acquisitions" element={<MergersAcquisitions />} />
          <Route path="/financial-consultancy" element={<FinancialConsultancyModeling />} />
          <Route path="/payment-gateway" element={<PaymentGatewayAggregatorSolutions />} />
          <Route path="/startup-planning" element={<StartupPlanningCSR />} />
          <Route path="/consumer-complaint" element={<ConsumerComplaint />} />
          <Route path="/cheque-bounce" element={<ChequeBounceNotice />} />

          {/* ==================== REGISTRATION ROUTES ==================== */}
          <Route path="/company-registration" element={<CompanyRegistration />} />
          <Route path="/private-limited-company-registration" element={<PvtCompanyRegistration />} />
          <Route path="/llp-registration" element={<LlpRegistration />} />
          <Route path="/public-limited-company-registration" element={<PublicLimitedCompanyRegistration />} />
          <Route path="/partnership-firm-registration" element={<PartnershipFirmRegistration />} />
          <Route path="/sole-proprietorship-registration" element={<SoleProprietorshipRegistration />} />
          <Route path="/one-person-company-registration" element={<OPCRegistration />} />
          <Route path="/startup-registration" element={<StartupRegistration />} />
          <Route path="/startup-india-registration" element={<StartupIndiaRegistration />} />
          <Route path="/indian-subsidiary-registration" element={<IndianSubsidiaryRegistration />} />
          <Route path="/foreign-subsidiary-registration" element={<ForeignSubsidiaryRegistration />} />
          <Route path="/foreign-company-registration-india" element={<ForeignCompanyRegistration />} />
          <Route path="/producer-company-registration" element={<ProducerCompanyRegistration />} />
          <Route path="/nidhi-company-registration" element={<NidhiCompanyRegistration />} />
          <Route path="/microfinance-company-registration" element={<MicrofinanceCompanyRegistration />} />
          <Route path="/ssi-registration" element={<SSIRegistration />} />
          <Route path="/virtual-office-registration" element={<VirtualOfficeRegistration />} />

          {/* NGO SERVICES */}
          <Route path="/ngo-registration" element={<NGORegistration />} />
          <Route path="/trust-registration" element={<TrustRegistration />} />
          <Route path="/society-registration" element={<SocietyRegistration />} />
          <Route path="/section-8-company" element={<Section8CompanyRegistration />} />
          <Route path="/section-8-microfinance" element={<Section8MicrofinanceRegistration />} />
          <Route path="/darpan-registration" element={<DarpanRegistration />} />
          <Route path="/12a-80g-registration" element={<NGO12A80GRegistration />} />
          <Route path="/fcra-registration" element={<FCARegistration />} />
          <Route path="/ngo-accounting" element={<NGOAccountingServices />} />

          {/* LICENSES & GOVERNMENT REGISTRATIONS */}
          <Route path="/wordmark-registration" element={<WordmarkRegistration />} />
          <Route path="/barcode-registration" element={<BarcodeRegistration />} />
          <Route path="/drug-license" element={<DrugLicenseRegistration />} />
          <Route path="/liquor-license" element={<LiquorLicenseRegistration />} />
          <Route path="/ayush-license" element={<AYUSHLicenseRegistration />} />
          <Route path="/factory-license" element={<FactoryLicenseRegistration />} />
          <Route path="/petrol-pump-license" element={<PetrolPumpLicenseRegistration />} />
          <Route path="/tobacco-license" element={<TobaccoLicenseRegistration />} />
          <Route path="/network-license" element={<NetworkLicenseRegistration />} />
          <Route path="/icegate-registration" element={<ICEGATERegistration />} />
          <Route path="/issn-registration" element={<ISSNNumberRegistration />} />
          <Route path="/isbn-registration" element={<ISBNNumberRegistration />} />
          <Route path="/professional-tax-registration" element={<ProfessionalTaxRegistration />} />
          <Route path="/ptec-registration" element={<PTECRegistration />} />
          <Route path="/rcmc-registration" element={<RCMCRegistration />} />
          <Route path="/spice-form-filing" element={<SPICePlusFormFiling />} />

          {/* ISO CERTIFICATIONS */}
          <Route path="/iso-certification" element={<ISOCertification />} />
          <Route path="/iso-9001" element={<ISO9001Certification />} />
          <Route path="/iso-14001" element={<ISO14001Certification />} />
          <Route path="/iso-22000" element={<ISO22000FSMSCertification />} />
          <Route path="/iso-27001" element={<ISO27001Certification />} />
          <Route path="/iso-31000" element={<ISO31000Certification />} />
          <Route path="/iso-50001" element={<ISO50001Certification />} />
          <Route path="/isi-mark" element={<ISIMarkCertification />} />

          {/* BIS & OTHER CERTIFICATIONS */}
          <Route path="/bis-certification" element={<BISCertification />} />
          <Route path="/bis-power-banks" element={<BISPowerBankCertification />} />
          <Route path="/bis-fmcs" element={<BISFMCSCertification />} />
          <Route path="/bis-toys" element={<BISToyCertification />} />
          <Route path="/sa8000-certification" element={<SA8000Certification />} />
          <Route path="/gmp-certification" element={<GMPCertification />} />

          {/* EXPORT & TRADE */}
          <Route path="/fieo-registration" element={<FIEORegistration />} />
          <Route path="/duns-registration" element={<DUNSNumberRegistration />} />
          <Route path="/geographical-indication" element={<GIRegistration />} />

          {/* FSSAI SERVICES */}
          <Route path="/fssai-registration" element={<FSSAIRegistration />} />
          <Route path="/fssai-state-license" element={<FSSAIStateLicense />} />
          <Route path="/fssai-central-license" element={<FSSAICentralLicense />} />
          <Route path="/fssai-product-approval" element={<FSSAIProductApproval />} />
          <Route path="/fssai-license-renewal" element={<FSSAILicenseRenewal />} />
          <Route path="/halal-certification" element={<HalalCertification />} />

          {/* LOCAL LICENSES */}
          <Route path="/trade-license" element={<TradeLicense />} />
          <Route path="/mstc-license" element={<MSTCLicense />} />
          <Route path="/gumasta-license" element={<GumastaLicense />} />
          <Route path="/rera-registration" element={<RERARegistration />} />
          <Route path="/nsic-registration" element={<NSICRegistration />} />
          <Route path="/peso-certificate" element={<PESOCertificate />} />
          <Route path="/hallmark-registration" element={<HallmarkRegistration />} />

          {/* COMMODITY BOARDS */}
          <Route path="/rubber-board" element={<RubberBoardRegistration />} />
          <Route path="/tea-board-registration" element={<TeaBoardRegistration />} />
          <Route path="/insurance-repository-registration" element={<InsuranceRepositoryRegistration />} />
          <Route path="/sepc-registration" element={<SEPCRegistration />} />
          <Route path="/gjepc-registration" element={<GJEPCRegistration />} />
          <Route path="/isp-license" element={<ISPLicenseRegistration />} />
          <Route path="/ijcepa-certificate" element={<IJCEPACertificate />} />
          <Route path="/fpo-mark" element={<FPOMarkCertification />} />
          <Route path="/spice-board" element={<SpiceBoardRegistration />} />
          <Route path="/bee-registration" element={<BEERegistration />} />

          {/* GOVERNMENT INITIATIVES */}
          <Route path="/make-in-india" element={<MakeInIndiaCertificate />} />
          <Route path="/zed-certification" element={<ZEDCertification />} />
          <Route path="/nsdc-registration" element={<NSDCRegistration />} />
          <Route path="/ngo-project-report" element={<NGOProjectReport />} />
          <Route path="/cmmi-certification" element={<CMMICertification />} />

          {/* EXPORT COUNCILS */}
          <Route path="/apeda-registration" element={<APEDARegistration />} />
          <Route path="/texprocil-registration" element={<TEXPROCILRegistration />} />
          <Route path="/good-standing-certificate" element={<CertificateOfGoodStanding />} />
          <Route path="/ce-certification" element={<CECertification />} />
          <Route path="/rni-registration" element={<RNIRegistration />} />
          <Route path="/cdsco-registration" element={<CDSCORegistration />} />
          <Route path="/ad-code-registration" element={<ADCodeRegistration />} />
          <Route path="/gsp-registration" element={<GSPRegistration />} />
          <Route path="/safta-license" element={<SAFTALicense />} />
          <Route path="/wpc-certificate" element={<WPCRegistration />} />
          <Route path="/agmark-license" element={<AGMARKLicenseRegistration />} />
          <Route path="/virtual-cfo" element={<VirtualCFO />} />
          <Route path="/registration/licensing-advisory" element={<RegistrationLicensing />} />

          {/* ==================== INTERNATIONAL REGISTRATIONS ==================== */}
          <Route path="/dubai-company-registration" element={<CompanyRegistrationDubai />} />
          <Route path="/dubai-free-zone" element={<DubaiFreeZoneRegistration />} />
          <Route path="/uk-company-registration" element={<UKCompanyRegistration />} />
          <Route path="/canada-company-registration" element={<CanadaCompanyRegistration />} />
          <Route path="/australia-company-registration" element={<AustraliaCompanyRegistration />} />
          <Route path="/usa-company-registration" element={<USACompanyRegistration />} />
          <Route path="/new-zealand-company-registration" element={<NewZealandCompanyRegistration />} />
          <Route path="/hongkong-company-registration" element={<HongKongCompanyRegistration />} />
          <Route path="/singapore-company-registration" element={<SingaporeCompanyRegistration />} />
          <Route path="/malaysia-company-registration" element={<MalaysiaCompanyRegistration />} />
          <Route path="/thailand-company-registration" element={<ThailandCompanyRegistration />} />
          <Route path="/indonesia-company-registration" element={<IndonesiaCompanyRegistration />} />
          <Route path="/qatar-company-registration" element={<QatarCompanyRegistration />} />
          <Route path="/oman-company-registration" element={<OmanCompanyRegistration />} />
          <Route path="/saudi-arabia-company-registration" element={<SaudiArabiaCompanyRegistration />} />
          <Route path="/france-company-registration" element={<FranceCompanyRegistration />} />
          <Route path="/germany-company-registration" element={<GermanyCompanyRegistration />} />
          <Route path="/italy-company-registration" element={<ItalyCompanyRegistration />} />
          <Route path="/sweden-company-registration" element={<SwedenCompanyRegistration />} />
          <Route path="/ireland-company-registration" element={<IrelandCompanyRegistration />} />
          <Route path="/netherlands-company-registration" element={<NetherlandsCompanyRegistration />} />
          <Route path="/mauritius-company-registration" element={<MauritiusCompanyRegistration />} />
          <Route path="/bvi-registration" element={<BritishVirginIslandsCompanyRegistration />} />

          {/* ==================== ADVISORY ROUTES ==================== */}
          <Route path="/advisory/cooperative-banking" element={<CooperativeBanking />} />
          <Route path="/advisory/tender-bid" element={<TenderBid />} />
          <Route path="/advisory/wealth-management" element={<WealthManagement />} />
          <Route path="/advisory/strategy-management" element={<StrategyManagement />} />
          <Route path="/advisory/hni-family-office" element={<HNIFamilyOffice />} />
          <Route path="/advisory/government-infrastructure" element={<GovernmentInfrastructure />} />
          <Route path="/advisory/g2g-treaties" element={<G2GTreaties />} />
          <Route path="/advisory/policy-advocacy" element={<PolicyAdvocacy />} />
          <Route path="/advisory/policy-advisory-government" element={<PolicyAdvisoryGovernment />} />

          {/* ==================== 404 FALLBACK ==================== */}
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
              <div className="text-center p-12 max-w-2xl mx-auto">
                <motion.div initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.5 }}>
                  <div className="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-700 mb-6">404</div>
                  <h1 className="text-5xl font-bold text-gray-900 mb-6">Page Not Found</h1>
                  <p className="text-xl text-gray-600 mb-10 leading-relaxed">Oops! The page you're looking for doesn't exist or has been moved.</p>
                  <motion.a href="/" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-bold text-lg rounded-2xl shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300">
                    <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    Return to Home
                  </motion.a>
                </motion.div>
              </div>
            </div>
          } />
        </Routes>

        <Footer />
      </div>

      <MobileBottomNavbar />

      <motion.button
        onClick={handleWhatsAppClick}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        whileHover={{ scale: 1.15, rotate: 5 }}
        whileTap={{ scale: 0.9 }}
        className="hidden md:flex fixed bottom-8 right-8 bg-[#25D366] text-white w-16 h-16 rounded-full shadow-2xl items-center justify-center z-50 hover:shadow-[0_0_30px_rgba(37,211,102,0.6)] transition-all duration-300 cursor-pointer"
        aria-label="Chat with us on WhatsApp"
      >
        <WhatsAppIcon size={38} />
      </motion.button>
    </BrowserRouter>
  );
}
